import React from 'react'

function NoData({title='No data found', style}) {
  return (
    <div className='card py-2' style={{width: '100%', ...style}}>{<h3 className='text-warn mb-0 mt-0'>{title}</h3>}</div>
  )
}

export default NoData